// extracted by mini-css-extract-plugin
export var bgDark = "access-component-module--bg-dark--3Ymb0";
export var container = "access-component-module--container--2rutb";
export var link = "access-component-module--link--Yo2SA";
export var category = "access-component-module--category--272Y0";